
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

import * as _ from 'lodash';
import { CommonParam } from '../models/CommonParam';
import { WidgetSearch } from '../models/WidgetSearch';
import { InventoryWeightedAverageDto } from '../models/InventoryWeightedAverageDto';
import { PdfResponse } from '../models/PdfResponse';
import { AfterHoursPOConfirmData } from '../models/AfterHoursPOConfirmData';

@Injectable()
export class OrderService extends BaseService {

    constructor(_http: HttpClient) {
        super(_http);
        this.baseUrl = this.rootUrl + "Order/";
        this.baseUrl_v2 = this.rootUrl_v2;
    }
    getFromId(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "Get/" + id
        return super.get(url_call);
    }
    test(): Observable<any> {
        let url_call: string = this.baseUrl + "CheckUserRightsForMobileConstruction"
        return super.get(url_call);
    }
    getAdditionalData(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetAdditionalData/" + id
        return this.get(url_call);
    }
    getFromNumber(number: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetFromNumber/" + number;
        return this.get(url_call);
    }
    getAttachments(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetAttachments/" + id;
        return this.get(url_call);
    }
    createAfterHoursPO(id: string, data: AfterHoursPOConfirmData): Observable<any> {
        let url_call: string = this.baseUrl + "CreateCpDispatchPickupOrder/" + id;
        return super.post(url_call, data);
    }
    getDocument(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDocument/" + id;
        return this.get(url_call);
    }
    attachmentsCombineAndDownload(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "AttachmentsCombineAndDownload/" + id;
        return this.get(url_call);
    }
    getSupplierLocation(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetSupplierLocation/" + id;
        return this.get(url_call);
    }
    getOrdersForDispatch(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetOrdersForDispatch/" + id;
        return super.get(url_call);
    }
    getOrderDetails(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetOrderDetails/" + id;
        return super.get(url_call);
    }
    getOrderDetailsByPart(orderId: string,inventoryId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetOrderDetails/" + orderId + "/" + inventoryId;
        return super.get(url_call);
    }
    getBillsForOrder(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetBillsForOrder/" + id;
        return super.get(url_call);
    }
    getPOBillInformation(param: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "GetPOBillInformation";
        return this._http.get(url_call, options);
    }
    getPOVendorCreditInformation(param: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "GetPOVendorCreditInformation";
        return this._http.get(url_call, options);
    }
    getOrderErrors(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetOrderErrors/" + id;
        return super.get(url_call);
    }
    getOrderNotes(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetOrderNotes/" + id;
        return super.get(url_call);
    }
    getOrderShippingAddress(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetOrderShippingAddress/" + id;
        return this.get(url_call);
    }
    getOfficeShippingAddress(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetOfficeShippingAddress/" + id;
        return this.get(url_call);
    }
    getOrderStatusHistory(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetOrderStatusHistory/" + id;
        return super.get(url_call);
    }
    GetOrderReviewDetail(search: WidgetSearch): Observable<any> {
        search.active = false;
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetOrderReviewDetail";
        return this._http.get(url_call, options);
    }
    saveOrderError(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveOrderError";
        return this._http.put(url_call, model, { headers });
    }
    saveAll(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveAll";
        return this._http.put(url_call, model, { headers });
    }
    saveNote(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveOrderNotes";
        return this._http.put(url_call, model, { headers });
    }
    noteSave(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "NoteSave";
        return this._http.put(url_call, model, { headers });
    }
    savePrimary(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "OrderSave";
        return this._http.put(url_call, model, { headers });
    }
    getEmailForOrder(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetEmailForOrder/" + id;
        return super.get(url_call);
    }
    deleteOrder(id: any, number: string): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "Delete/" + id + "/" + number;
        return this._http.delete(url_call, { headers });
    }
    saveOrderDetail(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveOrderDetail";
        return this._http.put(url_call, model, { headers });
    }
    deleteOrderDetail(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteOrderDetail/" + id;
        return this._http.delete(url_call, { headers });
    }
    deleteAttachment(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteAttachment/" + id;
        return this._http.delete(url_call, { headers });
    }
    deleteNote(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteNotes/" + id;
        return this._http.delete(url_call, { headers });
    }
    deleteOrderError(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteOrderError/" + id;
        return this._http.delete(url_call, { headers });
    }
    getReceivedForOrder(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetReceivedForOrder/" + id;
        return super.get(url_call);
    }
    getOrderReceivedDetailsGrid(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetOrderReceivedDetailsGrid/" + id;
        return super.get(url_call);
    }

    saveOrderReceiving(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveOrderReceiving";
        return this._http.put(url_call, model, { headers });
    }
    getOrderDetailsSelectItems(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetOrderDetailsSelectItems/" + id;
        return super.get(url_call);
    }
    getOrderDetailsByBillSelectItems(id: string, orderBillid: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetOrderDetailsByBillSelectItems/" + id + "/" + orderBillid ;
        return super.get(url_call);
    }
    getOrderBillDetailsGrid(orderId: string, orderBillId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetOrderBillDetailsGrid/" + orderId + "/" + orderBillId;
        return super.get(url_call);
    }
    saveOrderBills(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveOrderBills";
        return this._http.put(url_call, model, { headers });
    }
    updateWeightedAverages(model: InventoryWeightedAverageDto[]): Observable<any> {
        let url_call: string = this.baseUrl_v2 + "inventory/costs/wgtavg/update";
        return super.post(url_call, model);
    }
    SaveOrderBillApprove(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveOrderBillApprove";
        return this._http.put(url_call, model, { headers });
    }
    saveOrderBillBatchNo(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveOrderBillBatchNo";
        return this._http.put(url_call, model, { headers });
    }
    getVendorCredit(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetVendorCredit/" + id;
        return super.get(url_call);
    }

    saveVendorCredit(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveVendorCredit";
        return this._http.put(url_call, model, { headers });
    }
    getVendorReturn(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetVendorReturn/" + id;
        return super.get(url_call);
    }
    saveVendorReturn(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveVendorReturn";
        return this._http.put(url_call, model, { headers });
    }
    saveVendorReturnWithTransfer(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "saveVendorReturnWithTransfer";
        return this._http.put(url_call, model, { headers });
    }
    print(id: any): Observable<any> {
        let url_call: string = this.baseUrlCPConn + "PrintOrder/" + id;
        return super.get(url_call);
    }

    //calls 2.2 new pdf engine endpoint
    printUsingIronPdf(id: string): Observable<PdfResponse> {
        let url: string = this.baseUrl + id + "/pdf";
        return super.get(url);
    }
    printUsingIronPdfZuggit(id: string): Observable<PdfResponse> {
        let url: string = this.baseUrl + id + "/pdfZuggit";
        return super.get(url);
    }
    getListFromMaster(masterId: any): Observable<any> {
        let url_call: string = this.baseUrl + "GetListFromMaster/" + masterId;
        return super.get(url_call);
    }
    setOrderLineFromInventoryId(param: CommonParam): Observable<any> {
        let url_call: string = this.baseUrl + "SetOrderLineFromInventoryId";
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        return this._http.get(url_call, options);
    }

}
